angular.module('psModule').directive('psRisk', function() {
	return {
		restrict: 'E',
		scope: {
            value: '='
		},
		template:'<span class="hidden-xs"><span>{{value}}</span> <span class="max-risk-info" ng-if="value">(7)</span> <span ng-if="!value">-</span></span> <span class="visible-xs">{{value}}</span>'
	};
});
